  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.shippingBar = document.querySelector('.shipping-bar');
      this.headerGroup = document.querySelector('.header-group');
      this.mainContent = document.querySelector('#MainContent');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.headerModals = document.querySelectorAll('.header__modal-content');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      window.addEventListener('load', this.setHeaderHeight.bind(this));

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      if (/Android/i.test(navigator.userAgent) && /Mobile/i.test(navigator.userAgent)) {
        this.headerGroup.classList.add('header--android');
      }

      if (this.shippingBar != null) {
        if (!this.shippingBar.classList.contains('shipping-bar--hidden')) {
          document.querySelector('.shopify--section-shipping-bar').classList.add('has__shipping-class');
        };
      }

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.headerGroup.offsetHeight}px`);

      if (!this.mainContent.classList.contains('no-space')) {
        this.mainContent.style.paddingTop = `${this.headerGroup.offsetHeight}px`;
      };
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.headerGroup.classList.add('scrolled-past-header');
        this.removeShippingBarClass()

        if (this.preventHide) return;
        // requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.headerGroup.classList.add('scrolled-past-header');
        this.header.classList.add('scrolled-past-header');
        this.removeShippingBarClass()

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.headerGroup.classList.remove('scrolled-past-header');
        this.header.classList.remove('scrolled-past-header');
        this.addShippingBarClass();

        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    addShippingBarClass() {
      this.headerModals.forEach(headerModal => {
        if (this.shippingBar != null) {
          if (!this.shippingBar.classList.contains('shipping-bar--hidden')) {
            headerModal.classList.add('has-shipping-bar');
          };
        };
      });
    }

    removeShippingBarClass() {
      this.headerModals.forEach(headerModal => {
        headerModal.classList.remove('has-shipping-bar');
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      // this.closeMenuDisclosure();
      this.closeSearchModal();
      this.removeShippingBarClass();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');

      this.removeShippingBarClass();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

      this.addShippingBarClass();
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
